(() => {
  const COLOR_NAMES = ['beige', 'white', 'silver', 'black'];

  const normalizeColor = (value) => {
    const normalized = String(value || '').toLowerCase();
    if (normalized.includes('white')) return 'white';
    if (normalized.includes('silver') || normalized.includes('grey') || normalized.includes('gray')) return 'silver';
    if (normalized.includes('black')) return 'black';
    if (normalized.includes('beige') || normalized.includes('cream')) return 'beige';
    return '';
  };

  const initPurchase = (root) => {
    if (!root || root.dataset.dos68Ready === 'true') return;
    root.dataset.dos68Ready = 'true';

    const galleryImage = root.querySelector('[data-dos68-gallery-image]');
    const thumbs = Array.from(root.querySelectorAll('[data-dos68-thumb]'));
    const colorLabels = Array.from(root.querySelectorAll('[data-dos68-color-label]'));
    const viewLabel = root.querySelector('[data-dos68-view-label]');
    const count = root.querySelector('[data-dos68-gallery-count]');
    const variantOptions = Array.from(root.querySelectorAll('.variant_option'));
    const livePrice = root.querySelector('.yv-product-price');
    const stockLabels = Array.from(root.querySelectorAll('[data-dos68-stock]'));
    const variantDataElement = root.querySelector('[data-name="variant-json"]');
    let variants = [];
    if (variantDataElement) {
      try {
        variants = JSON.parse(variantDataElement.textContent);
      } catch (error) {
        variants = [];
      }
    }
    let currentColor = normalizeColor(root.dataset.initialColor) || 'beige';
    let currentView = 'angle';

    const syncVariantState = () => {
      variantOptions.forEach((option) => {
        const input = option.querySelector('.productOption');
        option.classList.toggle('is-selected', Boolean(input && input.checked));
      });
    };

    const syncFinalPrice = () => {
      if (!livePrice) return;
      document.querySelectorAll('.dos68-page [data-dos68-final-price]').forEach((price) => {
        price.textContent = livePrice.textContent.trim();
      });
    };

    const selectedOptions = () => Array.from(root.querySelectorAll('.product-option-selector')).map((selector) => {
      const selected = selector.querySelector('.productOption:checked') || selector.querySelector('select.productOption');
      return selected ? selected.value : '';
    });

    const syncStock = () => {
      const options = selectedOptions();
      const variant = variants.find((item) => item.options.every((value, index) => value === options[index]));
      if (!variant) return;
      stockLabels.forEach((label) => {
        label.textContent = variant.available ? 'In stock' : 'Currently unavailable';
      });
    };

    const show = (color, view = 'angle') => {
      const normalizedColor = normalizeColor(color) || currentColor;
      const availableForColor = thumbs.filter((thumb) => thumb.dataset.color === normalizedColor);
      const selected = availableForColor.find((thumb) => thumb.dataset.view === view) || availableForColor[0];
      if (!selected || !galleryImage) return;

      currentColor = normalizedColor;
      currentView = selected.dataset.view || 'angle';
      galleryImage.src = selected.dataset.src;
      galleryImage.alt = selected.dataset.alt;

      colorLabels.forEach((label) => {
        label.textContent = currentColor.charAt(0).toUpperCase() + currentColor.slice(1);
      });
      if (viewLabel) viewLabel.textContent = currentView.charAt(0).toUpperCase() + currentView.slice(1);
      if (count) {
        const index = Math.max(0, availableForColor.indexOf(selected));
        count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(availableForColor.length).padStart(2, '0')}`;
      }

      thumbs.forEach((thumb) => {
        const visible = thumb.dataset.color === currentColor;
        const active = visible && thumb === selected;
        thumb.hidden = !visible;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => show(thumb.dataset.color, thumb.dataset.view));
    });

    root.addEventListener('change', (event) => {
      const input = event.target.closest('.productOption');
      if (!input) return;
      syncVariantState();
      syncStock();
      const color = normalizeColor(input.value || input.title);
      if (color) show(color, 'angle');
    });

    const checkedColor = Array.from(root.querySelectorAll('.productOption:checked'))
      .map((input) => normalizeColor(input.value || input.title))
      .find((value) => COLOR_NAMES.includes(value));

    syncVariantState();
    syncFinalPrice();
    syncStock();
    show(checkedColor || currentColor, currentView);

    if (livePrice && typeof MutationObserver !== 'undefined') {
      new MutationObserver(syncFinalPrice).observe(livePrice, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-dos68-purchase]').forEach(initPurchase);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
